// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__3uxrT","wrapper":"video_wrapper__1MgVG","playerwrapper":"video_playerwrapper__lyVjA","textField":"video_textField__roob2"};